<template>
  <div class="musicInfoSkeleton">
    <div class="top">
      <creative-skeleton width="40px" height="40px" style="margin-right: 8px;" />
      <div class="info">
        <creative-skeleton width="200px" height="18px" />
        <creative-skeleton width="150px" height="12px" style="margin-top: 4px;" />
      </div>
      <creative-skeleton width="130px" height="14px" />
    </div>
  </div>
</template>
<script>
import { defineComponent } from '@vue/composition-api';
import CreativeSkeleton from '@/components/common/common-skeleton/index.vue';

export default defineComponent({
  components: {
    CreativeSkeleton,
  },
});
</script>

<style lang="scss" scoped>
.musicInfoSkeleton {
  background-color: $--color-neutral-grey-11;
  width: 100%;
  padding: 10px 8px;
  border-radius: 4px;
  background-color: #fcfcfc;
  .top {
    display: flex;
    align-items: center;
    .info {
      display: flex;
      flex-direction: column;
      margin-right: auto;
    }
  }
}
</style>
